import { render, staticRenderFns } from "./MarketCountry.vue?vue&type=template&id=efb4e6aa"
import script from "./MarketCountry.vue?vue&type=script&lang=js"
export * from "./MarketCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports